import React, { useEffect, useRef, useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import RsModal from '@Pages/RetroSynthesis/components/RsModal';
import cn from 'classnames';
import StructurePreviewComponent from '@Components/Results/structure/structure-preview.component';
import { KEYCODES } from '@Utils/KeyboardUtil';
import Button from '@Components/Button';
import { KeepFocusWrapper } from '@Hooks/KeepFocus';
import { TooltipConstants } from '@Components/Tooltip';
import PropTypes from 'prop-types';

import './RouteOverviewTreeTooltip.theme.scss';

/* eslint-disable no-use-before-define */
/* eslint-disable react-hooks/exhaustive-deps */
function RouteOverviewTreeTooltip({ treeTooltip, updateTreeThumbnailDetails }) {
  const tooltipRef = useRef();
  const [tooltipPosition, setTooltipPosition] = useState({ top: '100px', left: '100px' });
  const [closed, setClosed] = useState(false);
  const [substancePath, setSubstancePath] = useState(undefined);

  useEffect(() => {
    resizeHandler();
    const { data } = treeTooltip;
    if (isEmpty(data)) {
      setClosed(true);
    } else {
      setClosed(false);
      setSubstancePath(treeTooltip.data.substance && treeTooltip.data.substance.path);
    }
  }, [treeTooltip, closed]);

  useEffect(
    () => () => {
      setSubstancePath(undefined);
    },
    []
  );

  useEffect(() => {
    window.addEventListener('resize', resizeHandler);
    window.addEventListener('wheel', doClose);
    window.addEventListener('keydown', keyDownHandler);
    return () => {
      window.removeEventListener('resize', resizeHandler);
      window.removeEventListener('wheel', doClose);
      window.removeEventListener('keydown', keyDownHandler);
    };
  }, [treeTooltip]);

  // Effect to handle outside component click
  useEffect(() => {
    const handleClickOutside = (event) => {
      // eslint-disable-next-line no-unused-expressions
      tooltipRef.current && !tooltipRef.current.contains(event.target) && doClose();
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [treeTooltip, tooltipRef]);

  if (!treeTooltip) {
    return null;
  }

  const doClose = () => {
    if (treeTooltip && !isEmpty(treeTooltip.data)) {
      updateTreeThumbnailDetails();
    }
  };

  const resizeHandler = () => {
    const { target } = treeTooltip;
    if (target && tooltipRef.current) {
      const popupRect = tooltipRef.current.getBoundingClientRect();
      const targetRect = target.getBoundingClientRect();
      const windowScrollX = window.scrollX !== undefined ? window.scrollX : document.documentElement.scrollLeft;
      const windowScrollY = window.scrollY !== undefined ? window.scrollY : document.documentElement.scrollTop;
      const top = Math.round(windowScrollX + targetRect.top + targetRect.height / 2);
      const left = Math.round(windowScrollY + targetRect.left - popupRect.width + targetRect.width / 2);
      setTooltipPosition({ top: `${top}px`, left: `${left}px` });
    }
  };

  const keyDownHandler = (e) => {
    if (e && e.keyCode === KEYCODES.ESC) {
      doClose();
    }
  };

  return (
    <RsModal showModal={!isEmpty(treeTooltip.data) && !closed}>
      <KeepFocusWrapper needKeepFocus focusOnMount>
        <div
          className={cn('__react_component_tooltip show place-bottom rs-tooltip-big', TooltipConstants.clickableClassName)}
          style={tooltipPosition}
          ref={tooltipRef}
          tabIndex={-1}>
          <Button
            buttonConfig={{
              type: 'link',
              size: 'sm',
              className: 'els-btn-modal-close',
              e2eName: 'modal-close',
              ariaLabel: 'Close',
            }}
            iconConfig={{
              name: 'delete',
              size: 'tiny',
            }}
            onClick={doClose}
          />
          <div className="tree-thumbnails__container">
            <StructurePreviewComponent zoom={1} previewPath={substancePath} />
            {/* Place for "Find the same substance in different routes" button */}
          </div>
        </div>
      </KeepFocusWrapper>
    </RsModal>
  );
}
export default RouteOverviewTreeTooltip;

RouteOverviewTreeTooltip.propTypes = {
  treeTooltip: PropTypes.object,
  updateTreeThumbnailDetails: PropTypes.func,
};
